"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentUser = exports.fetchUserAttributes = void 0;
// Pattern 6 (Phase C4): bare re-export of the ctx-native main APIs. They accept
// `(ctx, input)` via overloads, so no server-specific wrapper or
// `resolveServerContext` is needed — the caller supplies a branded
// `AmplifyContext` as the first argument.
var __1 = require("../..");
Object.defineProperty(exports, "fetchUserAttributes", { enumerable: true, get: function () { return __1.fetchUserAttributes; } });
Object.defineProperty(exports, "getCurrentUser", { enumerable: true, get: function () { return __1.getCurrentUser; } });
